<template>
  <div>
    <v-flex xs12>
      <h2 class="text-center mb-5">Strømbestilling</h2>
    </v-flex>
    <v-flex xs12 v-if="!stepValues.powerOrderIsApproved">
      <v-flex xs12 sm8 offset-sm2 class="mb-5">
        <slick
          ref="slick"
          :options="slickOptions"
          @afterChange="updateCurrentSlide"
          v-if="slickReady"
        >
          <template v-for="(item, index) in powerSubs">
            <div class="text-center" :key="index + '1'">
              <img :src="item.img" class="mb-3 logo-img" />
              <h4>{{ item.title }}</h4>
              <p v-html="item.description"></p>
              <v-btn
                v-if="terms"
                flat
                small
                v-on:click.stop="termsDialog = true"
                >
                Avtalevilkår
              </v-btn
              >
            </div>
          </template>
        </slick>
        <div v-else>
          <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
      </v-flex>
      <v-flex xs12 sm8 offset-sm2 class="mt-5 text-center">
        <h3 class="mt-5 pt-4 pb-3">Skal strømbestilling gjennomføres ?</h3>
        <v-btn
          :disabled="powerSubs.length == 0"
          block
          color="primary"
          dark
          class="mt-2"
          v-on:click.stop="dialog = true"
          >Ja, jeg ønsker å bestille strøm</v-btn
        >
        <v-btn
          :disabled="powerSubs.length == 0"
          block
          color="secondary"
          class="mt-2"
          flat
          @click="next"
          >Nei, jeg ønsker ikke å bestille strøm</v-btn
        >
      </v-flex>
    </v-flex>
    <v-flex xs12 v-else>
      <v-flex xs12 sm8 offset-sm2 text-center>
        <v-card v-if="slickReady">
          <img :src="stepValues.powerSub.img" class="logo-img mt-3" />
          <v-card-title primary-title>
            <div class="w-100">
              <h3 class="headline mb-0">{{ stepValues.powerSub.company }}</h3>
              <div text-center>{{ stepValues.powerSub.title }}</div>
              <div text-center class="mt-3">
                Blir bestilt på:
                <strong
                  >{{ stepValues.selectedTenant.firstname }}
                  {{ stepValues.selectedTenant.lastname }}
                  {{ stepValues.selectedTenant.companyName }}</strong
                >
                når protokoll er levert.
              </div>
            </div>
          </v-card-title>
          <v-card-actions>
            <v-btn flat color="red" @click="regretPowerOrder">Angre</v-btn>
          </v-card-actions>
        </v-card>
        <div v-else>
          <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
      </v-flex>
      <StepButtons @next-page="next" @previous-page="previous" />
    </v-flex>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-toolbar :dark="protocol.dark" color="primary">
        <v-btn icon :dark="protocol.dark" @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Bestilling av strøm</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn :dark="!protocol.dark" flat @click="dialog = false"
            >Avbryt</v-btn
          >
        </v-toolbar-items>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <v-container fluid>
            <v-layout wrap>
              <v-flex xs12 sm8>
                <v-select
                  label="Velg ansvarlig for strømbestillingen"
                  v-model="stepValues.selectedTenant"
                  :items="tenants"
                  @change="tenantChange"
                >
                  <template slot="selection" slot-scope="data"
                    >{{ data.item.firstname }} {{ data.item.lastname }}
                    {{ data.item.companyName }}</template
                  >
                  <template slot="item" slot-scope="data"
                    >{{ data.item.firstname }} {{ data.item.lastname }}
                    {{ data.item.companyName }}</template
                  >
                </v-select>
              </v-flex>
              <v-flex xs12 sm4 class="mb-0 mb-sm-2">
                <v-btn
                  color="primary"
                  @click="editDialog = true"
                  class="btn-block ml-0 ml-sm-1"
                >
                  Legg til
                  <v-icon right dark>mdi-account-plus</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  type="text"
                  label="Fakturaadresse"
                  v-model="stepValues.powerOrderInfo.street"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 class="pr-sm-2">
                <v-text-field
                  type="text"
                  label="Postnr"
                  v-model="stepValues.powerOrderInfo.zip"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm8 class="pl-sm-2">
                <v-text-field
                  type="text"
                  label="Sted"
                  v-model="stepValues.powerOrderInfo.city"
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm8
                offset-sm2
                align-center
                text-center
                v-if="powerSubs.length > 0"
              >
                Strøm fra
                <strong>{{ powerSubs[currentSlide].company }}</strong> blir
                bestilt på
                <strong
                  >{{ stepValues.selectedTenant.firstname }}
                  {{ stepValues.selectedTenant.lastname }}
                  {{ stepValues.selectedTenant.companyName }}</strong
                >
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-flex xs12 sm8 offset-sm2>
          <v-btn color="success" block @click="powerOrderApproved"
            >Bekreft strømbestilling</v-btn
          >
        </v-flex>
        <person-editor
          v-if="editDialog"
          :user="newParticipant"
          @close-dialog="closePersonEditor"
          @person-saved="personSaved"
        ></person-editor>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="termsDialog"
      transition="dialog-bottom-transition"
      max-width="600"
    >
      <v-card>
        <v-card-text>
          <div v-html="termsText" v-if="termsText"></div>
          <PowerCompanyTerms v-if="terms && !termsText" :company="terms" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Slick from "vue-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import step from "../../mixins/step";
import Participant from "../../models/participant";
import PersonEditor from "../../components/form/PersonEditor";
import PowerCompanyTerms from "../../components/powerCompanies/terms/main";
export default {
  mixins: [step],
  data() {
    return {
      dialog: false,
      editDialog: false,
      termsDialog: false,
      tenants: [],
      slickOptions: {
        slidesToShow: 1,
        dots: true,
      },
      currentSlide: 0,
      powerSubs: [],
      slickReady: false,
      newParticipant: new Participant(),
    };
  },
  components: { Slick, PersonEditor, PowerCompanyTerms },
  beforeMount: function () {
    if (!this.stepValues.powerOrderInfo) {
      this.stepValues.powerOrderInfo = {
        street: this.protocol.saved_values.address.street
          ? JSON.parse(
              JSON.stringify(this.protocol.saved_values.address.street)
            )
          : "",
        zip: this.protocol.saved_values.address.zip
          ? JSON.parse(JSON.stringify(this.protocol.saved_values.address.zip))
          : "",
        city: this.protocol.saved_values.address.city
          ? JSON.parse(JSON.stringify(this.protocol.saved_values.address.city))
          : "",
      };
    }
    if (this.stepValues.selectedTenant.length == 0) {
      this.stepValues.selectedTenant = {
        firstname: "",
        lastname: "",
        companyName: "",
      };
    }
    if (!this.stepValues.additionalParticipants) {
      this.stepValues.additionalParticipants = [];
    }
  },
  activated: function () {
    this.tenants = this.getTenants();
    this.getPowerProducts();
    if (
      this.stepValues.selectedTenant.firstname == "" &&
      this.stepValues.selectedTenant.companyName == ""
    ) {
      this.stepValues.selectedTenant = this.tenants[0];
      this.tenantChange();
    }
  },
  computed: {
    terms() {
      if (this.powerSubs) {
        if (this.powerSubs[this.currentSlide]) {
          if (
            this.powerSubs[this.currentSlide].company == "Entelios"
          ) {
            return null;
          }
          return this.powerSubs[this.currentSlide].company;
        }
      }
      return null
    },
    termsText() {
      if (this.powerSubs) {
        if (this.powerSubs[this.currentSlide]) {
          return this.powerSubs[this.currentSlide].terms;
        }
      }
      return null
    },
  },
  methods: {
    getPowerProducts() {
      this.powerSubs = [];
      if (!this.stepValues.powerOrderIsApproved) {
        this.slickReady = false;
        this.axios
          .get(
            process.env.VUE_APP_PROTOCOL_API +
              "power_products/" +
              this.protocol.hash
          )
          .then((response) => {
            if (response.data) {
              this.powerSubs = response.data;
              this.slickReady = true;
            }
          })
          .catch(() => {
            this.$emit("error", "Feil: Kunne ikke hente strømabonnementer");
          });
      } else {
        this.slickReady = true;
      }
    },
    updateCurrentSlide() {
      this.currentSlide = this.$refs.slick.currentSlide();
    },
    powerOrderApproved() {
      if (
        this.stepValues.selectedTenant.firstname == "" &&
        this.stepValues.selectedTenant.companyName == ""
      ) {
        this.$emit(
          "error",
          "Vennligst velg hvem strømbestillignen skal stå på"
        );
        return false;
      }
      this.stepValues.powerOrderIsApproved = true;
      this.dialog = false;
      this.stepValues.powerSub = this.powerSubs[this.currentSlide];
      this.stepValues.powerSub = this.powerSubs[this.currentSlide];
      this.$ga.event(
        "protocol",
        "power_order_approved",
        this.powerSubs[this.currentSlide].company
      );
      this.protocol.saved_values.powerOrder = this.stepValues;
      this.protocol.saved_values.powerOrder.powerMeter = this.protocol.saved_values.steps.power.saved_values;
      this.updateFields();
    },
    regretPowerOrder() {
      this.stepValues.powerOrderIsApproved = false;
      delete this.protocol.saved_values.powerOrder;
      this.updateFields();
      this.getPowerProducts();
    },
    getTenants: function () {
      if (this.protocol.saved_values.participants) {
        if (
          this.protocol.saved_values.participants.tenants.length > 0 ||
          this.protocol.saved_values.participants.buyers.length > 0
        ) {
          let tenants = JSON.parse(
            JSON.stringify(this.protocol.saved_values.participants.tenants)
          );
          let buyers = JSON.parse(
            JSON.stringify(this.protocol.saved_values.participants.buyers)
          );
          for (let buyer in buyers) {
            tenants.push(buyers[buyer]);
          }
          let landlords = JSON.parse(
            JSON.stringify(this.protocol.saved_values.participants.landlords)
          );
          for (let landlord in landlords) {
            tenants.push(landlords[landlord]);
          }
          if (
            this.protocol.version.protocol_definition.department.company.options
              .power_order_companies
          ) {
            for (let c in this.protocol.version.protocol_definition.department
              .company.options.power_order_companies) {
              let company = this.protocol.version.protocol_definition.department
                .company.options.power_order_companies[c];
              if (
                company.defaultAlp != null &&
                company.defaultAlp != undefined &&
                this.protocol.version.protocol_definition.protocol_type_id == 2
              ) {
                tenants.unshift(company);
              } else {
                tenants.push(company);
              }
            }
          }
          if (this.stepValues.additionalParticipants.length > 0) {
            for (let a in this.stepValues.additionalParticipants) {
              tenants.unshift(this.stepValues.additionalParticipants[a]);
            }
          }
          return tenants;
        }
      }
      this.$emit("error", "Vennligst velg deltakere tilstede");
      this.$router.push("tilstede");
      return [{ firstname: "", lastname: "", companyName: "" }];
    },
    tenantChange: function () {
      if (this.stepValues.selectedTenant.address) {
        this.stepValues.powerOrderInfo.street = this.stepValues.selectedTenant.address.street;
        this.stepValues.powerOrderInfo.zip = this.stepValues.selectedTenant.address.zip;
        this.stepValues.powerOrderInfo.city = this.stepValues.selectedTenant.address.city;
      } else {
        this.stepValues.powerOrderInfo.street = this.protocol.saved_values.address.street;
        this.stepValues.powerOrderInfo.zip = this.protocol.saved_values.address.zip;
        this.stepValues.powerOrderInfo.city = this.protocol.saved_values.address.city;
      }
    },
    closePersonEditor() {
      this.editDialog = false;
    },
    personSaved(participant) {
      this.stepValues.additionalParticipants.unshift(participant);
      this.tenants = this.getTenants();
      this.stepValues.selectedTenant = participant;
      this.closePersonEditor();
    },
  },
};
</script>

<style>
.slick-slider {
  border: 1px solid #c9c9c9;
  padding: 20px 10px 0px;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(229, 229, 229, 1) 100%
  );
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
}
.slick-slide img,
.logo-img {
  display: inline;
  width: auto;
  height: 60px;
}
.slick-prev:before,
.slick-next:before {
  color: grey;
}
.slick-dots {
  bottom: -40px;
}
.slick-dots li button:before {
  font-size: 20px;
}
</style>
